import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Star, Quote } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      name: "KYP1969",
      location: "Binfield, Berkshire",
      text: "In a word, fantastic! I had inadvertently caused my electric garage door to get obstructed and I was unable to close it as a result. SmartLift Garage Doors were able to get to me quickly and deal with the issue, ensuring peace of mind. Prompt, courteous and professional service. Highly recommended. In fact I really can't recommend them enough!",
      rating: 5,
    },
    {
      name: "Daniel Jennings",
      location: "Reading, Berkshire",
      text: "We are very grateful, Smartlift doors came out at short notice on a dark Sunday evening, and provided friendly and efficient service, and our garage door was quickly repaired, with no additional costs. Thank you.",
      rating: 5,
    },
    {
      name: "Reena",
      location: "Reading, Berkshire",
      text: "Garage door broke at 16.30 today… literally not able to close it due to the cable snapping. Called Smartlift at 17.17 and they turned up at 19.25 - fixed by 20.20… unbelievably quick turnaround, super professional and fixed the problem asap. Biggest concern had been securing the garage for the evening, as well as whether the door itself was salvageable or a huge cost outlay. Highly recommend Smartlift - quick to respond, communicated ETA, came out that same evening and fixed it - four hours from door breaking to being fixed and property secure again is remarkable in my view! Reasonable prices too considering emergency call out and quick response times. Highly recommend.",
      rating: 5,
    },
  ];

  return (
    <section className="py-20 bg-foreground">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-background mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-background/70">
            Trusted by homeowners across Berkshire, Hampshire and Surrey
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-start">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="bg-background border-0 hover:shadow-xl transition-shadow h-full flex flex-col">
              <CardContent className="pt-6 flex flex-col flex-1">
                <Quote className="w-10 h-10 text-accent mb-4 shrink-0" />
                <div className="flex gap-1 mb-4 shrink-0">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-accent text-accent" />
                  ))}
                </div>
                <p className="text-muted-foreground mb-6 leading-relaxed text-sm flex-1">"{testimonial.text}"</p>
                <div className="pt-4 border-t border-border mt-auto shrink-0">
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          <p className="text-sm text-background">Rated 5.0 on Google</p>
          <Button size="sm" variant="outline" className="bg-transparent border-background/70 text-background hover:bg-background hover:text-foreground" asChild>
            <a href="https://maps.google.com/?cid=10431130324336682582" target="_blank" rel="noopener noreferrer">
              Read our Google reviews
            </a>
          </Button>
          <Button size="sm" variant="outline" className="bg-transparent border-background/70 text-background hover:bg-background hover:text-foreground" asChild>
            <a href="https://search.google.com/local/writereview?placeid=ChIJ8y7pPzYqb6IRVqbkc8PRwpA" target="_blank" rel="noopener noreferrer">
              Leave us a review
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
